<template>
  <p class="p-heading3">
    <slot />
  </p>
</template>

<script>
export default {}
</script>

<style scoped>
.p-heading3 {
  /* Base */
  font-family: 'Exo 2', sans-serif;
  @apply tw-text-[#46214A] tw-font-medium tw-text-[16px] tw-leading-[19px] tw-text-center tw-tracking-[-0.01em];

  /* Desktop */
  @apply lg:tw-text-[24px] lg:tw-leading-[29px] lg:tw-tracking-normal;
}
</style>
